import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { Link } from "react-router-dom";
import style from "../lander.css";
import "./HomeNavBar.css";
import Login from "../../auth/Login";
import Reset from "../../auth/password/Reset";
import { isLoggedIn } from "../../../services/user";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';


export class LanderHeader extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);

        this.state = {
            login: false,
            resetPassword: "",
            userSteps: localStorage.getItem('user_steps'),
            is_auth: false,
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    async componentWillMount() {
        const profile = await this.isAuth()
        if (profile == 'false' && localStorage.getItem('auth_token')) {
            window.location.href = "/logout";
        }
    };
    componentDidMount() {
        if (this.props.prompt === 'login') {
            this.setState({ resetPassword: false, login: true });
        }
    };

    isAuth = async () => {
        let that = this;
        return isLoggedIn()
            .then(res => {
                that.setState({ is_auth: res.data });
                console.log(that.state.is_auth);
                return res.data;
            })
            .catch(error => {
                console.log(error);
            });
    };

    toggleLogin = () => {
        //console.log(this.context.state.isAuth()  ? '1' : '0');
        if (this.context.state.isAuth()) {
            this.setState({ resetPassword: false, login: false });
            if (this.context.state.user.type === "employer") {
                window.location = "/employer/account";
            }
            if (this.context.state.user.type === "admin") {
                window.location = "/admin/dashboard";
            }
            if (this.context.state.user.type === "writer") {
                window.location = "/account";
            }

        }
        else {
            this.setState({ resetPassword: false, login: this.state.login === true ? false : true });
        }

    };

    toggleResetPassword = () => {
        this.setState({ login: false, resetPassword: this.state.resetPassword === true ? false : true });
    };

    hideAll = () => {
        this.setState({ login: false });
    };

    render() {
        return (
            <Fragment>
                {/* <section className="header mb-0 lander-header">
                    <div className="container">
                        <div className="sub-container mx-auto pl-lg-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <img src={`/images/logo.png`} alt="logo" width="142" height="30" />
                                <div className="d-flex align-items-center links">
                                    <Link className="mr-4 d-sm-block d-none" to="/jobs/hire-writers">Hire Writers</Link>
                                    <button className={this.context.state.isAuth() ? ((this.state.userSteps == 'account') ? 'border img' : 'border initials') : 'border'} onClick={this.toggleLogin}>
                                        {this.context.state.isAuth() ? '' : <i className="fa fa-user mr-2"></i>}
                                        {(this.context.state.isAuth() && (this.context.state.user) != null) ?
                                            ((this.state.userSteps == 'account')
                                                ? <img className="avatar-img user-avatar-img rounded-circle" src={this.context.state.user.image} />
                                                : this.context.state.getInitial((this.context.state.user != null ? this.context.state.user.first_name : '') + ' ' + (this.context.state.user != null ? this.context.state.user.last_name : '')))
                                            : `Member Login`}
                                    </button>

                                </div>
                            </div>
                            {this.state.login === true ? <Login toggleResetPassword={this.toggleResetPassword} toggleLogin={this.toggleLogin}></Login> : ""}
                            {this.state.resetPassword === true ? <Reset toggleResetPassword={this.toggleResetPassword}></Reset> : ""}
                        </div>
                    </div>
                </section> */}


                <Navbar className="home-header header mb-0" color="light" light expand="lg">
                    <div className="d-flex justify-content-between align-items-center nav-wrapper">
                        <NavbarBrand href="/">
                            <img src={`/images/logo.png`} alt="logo" width="142" height="30" />
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggle} />
                    </div>
                    <Collapse className="w-full navbar-right" isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto align-items-center" navbar>
                       { (!this.context.state.isAuth() || (this.context.state.isAuth() && this.context.state.user.type === "employer")) ?
                            <NavItem>
                                <NavLink className="nav-link btn btn-primary-alt btn-rounded text-uppercase fs-16 fw-700" href={!this.context.state.isAuth() ?'/register?next=post-job':'/employer/jobListing/create'}>
                                    Post a Job
                                </NavLink>
                            </NavItem>
                            :''
                        }
                            <NavItem className="nav-item-br">
                                <NavLink className="nav-link btn btn-success-alt btn-rounded text-uppercase fs-16 fw-700" href="/jobs">
                                    Find Jobs
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link-primary" href="javascript:;" onClick={this.toggleLogin}>
                                {(this.context.state.isAuth() && (this.context.state.user) != null) ?
                                            ((this.state.userSteps == 'account')
                                                ? <img className="avatar-img user-avatar-img rounded-circle" src={this.context.state.user.image} />
                                                : this.context.state.getInitial((this.context.state.user != null ? this.context.state.user.first_name : '') + ' ' + (this.context.state.user != null ? this.context.state.user.last_name : '')))
                                            : `Log In`}
                                </NavLink>
                            </NavItem>
                            {!this.context.state.isAuth()?
                            <NavItem>
                                <NavLink className="nav-link-primary" href="\register" >Sign Up</NavLink>
                            </NavItem>
                            :''}
                        </Nav>
                    </Collapse>
                </Navbar>


                {this.state.login === true ? <Login toggleResetPassword={this.toggleResetPassword} toggleLogin={this.toggleLogin}></Login> : ""}
                {this.state.resetPassword === true ? <Reset toggleResetPassword={this.toggleResetPassword}></Reset> : ""}
            </Fragment>
        );

    }
}

LanderHeader.contextType = AppContext;
export default LanderHeader;



// WEBPACK FOOTER //
// ./src/components/general/include/LanderHeader.js